import { send } from 'server';

export const startPhoneVerification = () => send({
    ID: 35562,
    responses: [35563, 35564],
    realMode: true,
    description: 'Start mobile phone verification'
});

export const sendPhoneVerificationCode = data => send({
    ID: 35565,
    responses: [35566, 35567],
    ...data,
    description: 'Verify mobile phone'
});
